import {useEffect} from 'react';

const useFileDownloader = (data, isLoading) => {
    useEffect(() => {
        if (data && !isLoading) {
            const url = window.URL.createObjectURL(new Blob([data.blob]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', data.filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }, [data, isLoading]);
};

export default useFileDownloader;
